import module from 'contabilidad/declaracionIsn/module'

export const schema = {
  id: 'number',
}

export class CatalogoRegimenFiscalService {
  constructor ($http) {
    this.$http = $http
  }

  get () {
    return this.$http.get(`api/catalogo/regimenes_fiscales`, {schema})
  }
}

module.service('catalogoRegimenFiscal', CatalogoRegimenFiscalService)



// WEBPACK FOOTER //
// ./src/contabilidad/declaracionIsn/services/Catalogos/RegimenFiscal.js